import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { GroupSessionsCreateModal } from './GroupSessionsCreateModal';

type GroupSessionsCreateModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type GroupSessionsCreateModalOpenerProps = {
   children: (renderProps: GroupSessionsCreateModalOpenerRenderProps) => JSX.Element;
};

export const GroupSessionsCreateModalOpener = (props: GroupSessionsCreateModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <GroupSessionsCreateModal onClose={closeModal} /> : null}
      </>
   );
};
